export default __webpack_public_path__ + "static/media/news2402294.9888d672.jpg";